const yup = require("yup");

export const paymentSchema = yup.object().shape({
  consultationFee: yup.number().required("Consultation fee is required"),
  consulationDays: yup.number().required("Consultation days are required"),
  medicineCharge: yup.number().required("Medicine charge is required"),
  medicineDays: yup.number().required("Medicine days are required"),
  mode: yup.number().required("Mode of payment is required"),
});
